import { authentication, app } from '@microsoft/teams-js';
import { useEffect } from 'react';

import { TEAMS_TOKEN_KEY } from '~/hooks/useRuntimeAwareAuth/useRuntimeAwareAuth';

export const TeamsAuthCallback = () => {
  useEffect(() => {
    const handleAuthResponse = async () => {
      await app.initialize();

      // Parse URL fragment or query for tokens and state
      const hash = window.location.hash.substring(1); // strip the leading '#'

      const params = new URLSearchParams(hash);
      const idToken = params.get('id_token');
      const accessToken = params.get('access_token');
      const error = params.get('error') || params.get('error_description');

      if (error) {
        // Keycloak returned an error (e.g., access_denied)
        authentication.notifyFailure(error);
      } else if (!idToken || !accessToken) {
        authentication.notifyFailure('Missing tokens');
        return;
      } else {
        const tokens = JSON.stringify({ id_token: idToken, access_token: accessToken });
        try {
          window.localStorage.setItem(TEAMS_TOKEN_KEY, tokens);
        } catch (e) {
          console.info('Failed to store token in localStorage', e);
          /* storage might be unavailable in popup, so just best-effort */
        }
        authentication.notifySuccess(tokens);
      }
    };

    (async () => {
      try {
        await handleAuthResponse();
      } catch (error) {
        console.error('Error handling Teams auth response:', error);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        authentication.notifyFailure(errorMessage);
      }
    })();
  }, []);

  return <div>Completing authentication...</div>;
};
